<template>
  <div class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Adicionar Consulta ao Template "{{ template.name }}"</h1>
      </div>
    </div>

    <new-query
      tag="cnpj"
      :template="template"
      consultations-route="/template/legal-person"
    />
  </div>
</template>

<script>
import NewQuery from '@/template/components/NewQuery.vue';
import { mapState } from 'vuex';

export default {
  name: 'Create',

  components: {
    NewQuery,
  },

  computed: {
    ...mapState('template', [
      'template',
    ]),
  },

  methods: {
    async loadTemplate() {
      await this.$store.dispatch('template/fetchTemplate', this.$route.params.id);
    },
  },

  mounted() {
    this.loadTemplate();
  },
};
</script>

<style lang="scss" scoped>

</style>
